const loginPageTranslations = {
  formTitle: "حول شكل جسمك الان مع",
  formTitleHook: "انفورما",
  subtitle: "انت علي بعد خطوة واحدة من تحويل شكل جسمك",
  form: {
    username: "اسم المستخدم",
    password: "كلمة السر",
    submit: "تسجيل دخول",
  },
};

export default loginPageTranslations;
